import { VOIP_NUMBER_POOL_GET_PREFIXES } from "./constants";
import { VoipNumberPoolState } from "./module";

const getPrefixes = (state: VoipNumberPoolState): string[] => {
	return state.prefixes;
};

export default {
	[VOIP_NUMBER_POOL_GET_PREFIXES]: getPrefixes
};
